<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">

    <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="$store.state.menuBuilder.unsavedLayout">
        <span>{{ $t('MENU.BUILDER.AttentionUnsavedLayout') }}</span>
    </vs-alert>


    <!-- Content Row -->
<div class="vx-row">
    <div class="vx-col md:w-1/2 w-full">
        <label class="vs-input--label">{{$t('MENU.BUILDER.Role')}}</label>
        <v-select style="z-index: 200001" v-model="menuData.role" label="name" @input="getRoleMenu" :clearable="false" :options="selectOptions.roleOptions" name="menu_type" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
    </div>
</div>
<div class="vx-row">
    <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" :label="$t('MENU.BUILDER.Name')" v-model="menuData.name" autocomplete="off" name="name" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
    </div>
    <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
            <label class="vs-input--label">{{$t('MENU.BUILDER.Type')}}</label>
            <v-select v-model="menuData.type" label="name" :clearable="false" :options="selectOptions.menuTypeOptions" name="menu_type" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="typeDisabled"/>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
    </div>
</div>
<div class="vx-row">
    <div class="vx-col md:w-1/3 w-full">
        <div class="mt-4">
            <label class="vs-input--label">{{$t('MENU.BUILDER.InsertInto')}}</label>
            <v-select v-model="menuData.addTo" label="name" @input="validateAddTo" class="addto-select" :clearable="false" :options="anchorsAndGroups" name="addto" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="addToDisabled">
                <template v-slot:option="option">
                    <span v-if="option.type === 'title'" style="font-weight: bold!important; margin-left: -8px!important; cursor: default!important;" onclick="return false">{{ option.name }}</span>
                    <span v-else>{{ option.name }}</span>
                </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
    </div>
    <div class="vx-col md:w-1/3 w-full">
        <div class="mt-4">
            <label class="vs-input--label">{{$t('MENU.BUILDER.Icon')}}</label>
            <v-select v-model="menuData.icon" label="name" class="addto-select" :clearable="false" :options="selectOptions.menuIcons" name="icon" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="iconDisabled">
                <template v-slot:option="option">
                    <feather-icon :icon="option.value" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer"/> {{ option.name }}
                </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
    </div>
    <div v-if="menuData.type.value === 3" class="vx-col md:w-1/3 w-full">
        <div class="mt-4">
            <label class="vs-input--label">{{$t('MENU.BUILDER.DirectedTo')}}</label>
            <v-select v-model="directTo" class="directto-select" :clearable="false" :options="selectOptions.directToOptions" name="direct-to" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="directToDisabled"/>
        </div>
    </div>
</div>

<div class="vx-row">
    <div class="vx-col md:w-1/3 w-full" v-show="menuData.type.value === 4 || menuData.type.value === 5">
        <div class="mt-4">
            <vs-input class="w-full mt-4" :label="$t('MENU.BUILDER.ExternalLink')" v-model="menuData.externalLink" autocomplete="off" name="external-link" />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
    </div>
    <div class="vx-col md:w-1/3 w-full" v-show="showCorrespondsToModule">
        <div class="mt-4">
            <label class="vs-input--label">{{$t('MENU.BUILDER.CorrespondsToModule')}}</label>
            <v-select v-model="menuData.module" class="module-select" label="name" :clearable="false" :options="selectOptions.moduleOptions" name="module" :disabled="correspondsToDisabled" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
    </div>
    <div class="vx-col md:w-1/3 w-full" v-show="showCorrespondsToDashboard">
        <div class="mt-4">
            <label class="vs-input--label">{{$t('MENU.BUILDER.CorrespondsToDashboard')}}</label>
            <v-select v-model="menuData.dashboard" class="module-select" label="name" :clearable="false" :options="selectOptions.dashboardOptions" name="module" :disabled="correspondsToDisabled" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
    </div>
      <div class="vx-col md:w-1/3 w-full" v-show="!moduleActionsDisabled">
        <div class="mt-4">
          <label class="vs-input--label">Adicionar à função do módulo</label>
          <v-select
            v-model="menuData.moduleAction"
            label="name"
            class="addto-select"
            :clearable="false"
            :options="selectOptions.moduleActionOptions"
            name="module-action"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :disabled="moduleActionsDisabled"
          >
            <template v-slot:option="option">
              <span v-if="option.type === 'title'" style="font-weight: bold!important; margin-left: -8px!important; cursor: default!important;" onclick="return">{{ option.name }}</span>
              <span v-else>{{ option.name }}</span>
            </template>
          </v-select>
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>
      <div class="vx-col md:w-1/3 w-full" v-show="menuData.module.type_id === 3 && (menuData.moduleAction.value === 'view' || menuData.moduleAction.value === 'edit')">
        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Registro do Módulo" v-model="menuData.moduleRecord" autocomplete="off" name="name" />
          <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
      </div>
      <div class="vx-col md:w-1/3 w-full" v-show="!moduleListDisabled">
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('MENU.BUILDER.AddToModuleFunction') }}</label>
          <v-select
            v-model="menuData.moduleList"
            label="name"
            class="addto-select"
            :clearable="false"
            :options="selectOptions.moduleListOptions"
            name="module-action"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :disabled="moduleListDisabled"
          >
          </v-select>
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>
    </div>


    <br><br><br><br><br><br><br><br><br><br><br>

    <!-- Save & Reset Button -->
    <div class="vx-row" style="margin-top: 20px!important;">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{ menuForm.buttonLabel }}</vs-button>
          <vs-button class="ml-4 mt-2" @click="cancelButtonClick" type="border" color="warning">{{ menuForm.clearLabel }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { performFetch } from '../../helpers.js'

export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {

      moduleListDisabled: true,
      showCorrespondsToDashboard: false,
      showCorrespondsToModule: false,

      menuForm: {
        action: 1,
        buttonLabel: this.$t('MENU.BUILDER.add_menu'),
        clearLabel: this.$t('MENU.BUILDER.clear')
      },

      typeDisabled: false,
      lastMenuLayout: null,
      configdateTimePicker: {
        time_24hr: true,
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      directTo: {},
      selectOptions: {
        dashboardOptions: [],
        moduleListOptions: [],
        roleOptions: [],
        moduleOptions: [],
        directToOptions: [
          {
            value: 'module',
            label: this.$t('MENU.BUILDER.Module')
          },
          {
            value: 'dashboard',
            label: this.$t('MENU.BUILDER.Dashboard')
          }
        ],
        moduleActionOptions: [
          {
            value: 'list',
            name: this.$t('MENU.BUILDER.list')
          },
          {
            value: 'view',
            name: this.$t('MENU.BUILDER.view')
          },
          {
            value: 'add',
            name: this.$t('MENU.BUILDER.add')
          },
          {
            value: 'edit',
            name: this.$t('MENU.BUILDER.edit')
          },
          {
            value: 'search',
            name: this.$t('MENU.BUILDER.search')
          }
        ],
        menuTypeOptions: [
          {
            value: 1,
            name:  this.$t('MENU.BUILDER.anchor')
          },
          {
            value: 2,
            name: this.$t('MENU.BUILDER.group')
          },
          {
            value: 3,
            name: this.$t('MENU.BUILDER.item')
          },
          {
            value: 4,
            name: this.$t('MENU.BUILDER.external_link')
          },
          {
            value: 5,
            name: this.$t('MENU.BUILDER.external_redirect')
          }
        ],
        menuIcons: []
      },
      isAdmin: false,
      status: 1,
      menuData: {
        name: '',
        moduleList: {},
        dashboard: {},
        icon: {},
        module: {},
        type: {},
        addTo: {},
        moduleAction: {},
        role: {},
        moduleRecord: '',
        externalLink: ''
      }
    }
  },
  computed: {
    directToDisabled () {
      return this.iconDisabled
    },
    iconDisabled () {
      if (this.menuData.type.value === 1) {
        return true
      } else if (this.menuData.type && Object.keys(this.menuData.type).length === 0 && this.menuData.type.constructor === Object) {
        return true
      } else if (this.menuData.type.value === 3 && this.menuData.addTo.type === 'group') {
        return true
      } else {
        return false
      }
    },
    addToDisabled () {
      if (this.menuData.type.value === 1) {
        return true
      } else if (this.menuData.type && Object.keys(this.menuData.type).length === 0 && this.menuData.type.constructor === Object) {
        return true
      } else {
        return false
      }
    },
    correspondsToDisabled () {
      if (this.menuData.type.value === 1 || this.menuData.type.value === 2 || this.menuData.type.value === 4) {
        return true
      } else if (this.menuData.type && Object.keys(this.menuData.type).length === 0 && this.menuData.type.constructor === Object) {
        return true
      } else {
        return false
      }
    },
    moduleActionsDisabled () {
      if (this.menuData.module.type_id !== 3) {
        return true
      } else if (this.menuData.module && Object.keys(this.menuData.module).length === 0 && this.menuData.module.constructor === Object) {
        return true
      } else {
        return false
      }
    },
    externalLinkShow () {
      if (this.menuData.type.value === 4) {
        return true
      } else {
        return false
      }
    },
    anchorsAndGroups () {
      if (this.menuData.type.value === 2) {
        return this.getAnchorsAndAllGroupsLevelOne()
      } else {
        return this.getAnchorsAndAllGroups()
      }
    },
    menuToEdit () {
      return this.$store.state.menuBuilder.currentMenuToEdit
    },
    menuToDelete () {
      return this.$store.state.menuBuilder.currentMenuToDelete
    }
  },
  watch: {
    async 'directTo' (newValue) {
      if (newValue.hasOwnProperty('value')) {
        if (newValue.value === 'dashboard') {
          await this.getDashboards()
          this.showCorrespondsToDashboard = true
          this.showCorrespondsToModule = false
        } else if (newValue.value ===  'module') {
          this.showCorrespondsToModule = true
          this.showCorrespondsToDashboard = false
        }
      }
    },
    'menuData.module' (newValue) {
      this.menuData.moduleAction = {}
    },
    async 'menuData.moduleAction' (newValue, oldValue) {
      if (newValue.hasOwnProperty('value') && newValue.value === 'list') {
        this.moduleListDisabled = false
        await this.getApplicationModuleLists(this.menuData.module.hash)
      } else {
        this.moduleListDisabled = true
      }
    },
    menuToEdit (newMenu, oldMenu) {
      this.prepareEditMenu(newMenu)
    },
    menuToDelete (newMenu, oldMenu) {

      const menuElement = document.querySelector(`[data-hash="${newMenu.hash}"]`)

      let menuName = ''

      if (menuElement.classList.contains('vs-sidebar--item')) {
        menuName = menuElement.querySelector('a > span.truncate').textContent
      } else if (menuElement.classList.contains('vs-sidebar-group')) {
        menuName = menuElement.querySelector('div.group-header > span.flex > span.truncate').textContent
      } else if (menuElement.classList.contains('navigation-header')) {
        menuName = menuElement.querySelector('span').textContent
      }

      let message = ''

      this.$store.state.auth.menu.forEach((item) => {
        if (item.hash === newMenu.hash) {
          message = `Todos os itens anexados ao menu serão excluídos, caso queira preservá-los, mova-os antes de excluir. Você tem certeza que deseja excluir o menu "${menuName}"`
        } else {
          item.items.forEach((itemLevel2) => {
            if (itemLevel2.hasOwnProperty('submenu') && itemLevel2.hash === newMenu.hash) {
              message = `Todos os itens anexados ao menu serão excluídos, caso queira preservá-los, mova-os antes de excluir. Você tem certeza que deseja excluir o menu "${menuName}"`
            } else if (itemLevel2.hasOwnProperty('submenu')) {
              itemLevel2.submenu.forEach((itemLevel3) => {
                if (itemLevel3.hasOwnProperty('submenu') && itemLevel3.hash === newMenu.hash) {
                  message = `Todos os itens anexados ao menu serão excluídos, caso queira preservá-los, mova-os antes de excluir. Você tem certeza que deseja excluir o menu "${menuName}"`
                }
              })
            }
          })
        }
      })

      if (message === '') {
        message = `Você tem certeza que deseja excluir o menu "${menuName}"`
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: message,
        accept: this.deleteMenu,
        acceptText: 'Excluir'
      })
    }
  },

  async mounted () {
    document.title = `${document.title.split(' | ')[0]  } | Menu Builder`

    this.$store.commit('auth/SET_APPLICATION_MENU', [])

    this.$vs.loading({type: 'default'})

    await this.$store.dispatch('menuBuilder/fetchParameters').then(status => {
      if (status === 200) {
        setTimeout(() => {
          this.selectOptions.roleOptions = this.$store.state.menuBuilder.roles
          this.selectOptions.menuIcons = this.$store.state.menuBuilder.icons
          this.selectOptions.moduleOptions = this.$store.state.menuBuilder.modules
          this.$vs.loading.close()
        }, 300)
      } else if (status === 401) {
        this.$vs.loading.close()
      } else {
        this.$vs.loading.close()
      }
    })

    // setTimeout(() => {

    //   this.selectOptions.roleOptions = JSON.parse(JSON.stringify(this.$store.state.menuBuilder.roles))
    //   this.selectOptions.menuIcons = JSON.parse(JSON.stringify(this.$store.state.menuBuilder.icons))
    //   this.selectOptions.moduleOptions = JSON.parse(JSON.stringify(this.$store.state.menuBuilder.modules))

    //   this.$vs.loading.close()
    // }, 500)
  },
  created () {
    this.initView()
  },
  methods: {
    async getDashboards () {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_dashboards',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_dashboards',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.selectOptions.dashboardOptions = []

              responseData.dashboards.forEach((item) => {
                this.selectOptions.dashboardOptions.push({hash: item.hash, name: item.name})
              })

              this.selectOptions.dashboardOptions.sort((a, b) => {
                if (a.name < b.name) {
                  return -1
                }
                if (a.name > b.name) {
                  return 1
                }
                return 0
              })
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Atenção!',
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getApplicationModuleLists (moduleHash) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_get_application_module_lists',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: moduleHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_get_application_module_lists',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: moduleHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.selectOptions.moduleListOptions = []

              responseData.lists.forEach((item) => {
                this.selectOptions.moduleListOptions.push({hash: item.hash, name: item.name})

                if (item.core) {
                  this.menuData.moduleList = {hash: item.hash, name: item.name}
                }
              })

            // this.lists = responseData.lists
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Atenção!',
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    validateAddTo (event) {
      if (event.type === 'title') {

        this.$vs.notify({
          title: 'Atenção!',
          text: 'Selecione uma opção válida no campo Inserir Em',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
    },
    setParentHash () {
      const menuItems = document.querySelector('.vs-sidebar--items > div > section > div')

      let currentParentHash = ''

      menuItems.children.forEach((item) => {

        if (item.classList.contains('vs-sidebar-group')) {
          const groupParentHash = item.getAttribute('data-hash')

          item.setAttribute('data-parent-hash', currentParentHash)

          item.querySelector('ul > div').children.forEach((itemLevel2) => {

            if (itemLevel2.querySelector('ul')) {
              itemLevel2.querySelector('ul > div').children.forEach((itemLevel3) => {
                itemLevel3.querySelector('div').setAttribute('data-parent-hash', itemLevel3.parentElement.parentElement.parentElement.getAttribute('data-hash'))
              })
            }

            itemLevel2.querySelector('div').setAttribute('data-parent-hash', groupParentHash)
          })
        } else if (item.tagName.toLowerCase() !== 'span') {
          item.setAttribute('data-parent-hash', currentParentHash)
        }

        if (item.tagName.toLowerCase() === 'span') {
          currentParentHash = item.getAttribute('data-hash')
        }
      })
    },
    cancelButtonClick () {
      if (this.menuForm.action === 2) {
        this.prepareAddMenu()
      } else {
        this.menuForm.action = 2
        this.menuData.type = {}
        this.menuData.addTo = {}
        this.menuData.icon = {}
        this.menuData.module = {}
        this.menuData.name = ''
        this.typeDisabled = true
      }
    },
    async getRoleMenu (val) {

      this.$store.commit('menuBuilder/SET_ROLE', val)

      this.$vs.loading({type: 'default'})

      // await fetch(this.$store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_role_mainmenu',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       role_hash: this.menuData.role.hash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_role_mainmenu',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          role_hash: this.menuData.role.hash
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {

              await this.$store.dispatch('auth/buildApplicationMenu', response.mainmenu)

              this.$vs.loading.close()

              setTimeout(() => {
                document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
                  item.classList.remove('router-link-exact-active')
                  item.classList.remove('router-link-active')
                })
              }, 300)

              this.$store.dispatch('auth/reloadState')

              this.setParentHash()
            })
          } else if (response.status == 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao carregar o menu do cargo.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao carregar o menu do cargo.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    async deleteMenu () {
      // await fetch(this.$store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'delete_application_role_mainmenu_item',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       role_hash: this.menuData.role.hash,
      //       menu_hash: this.$store.state.menuBuilder.currentMenuToDelete.hash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'delete_application_role_mainmenu_item',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          role_hash: this.menuData.role.hash,
          menu_hash: this.$store.state.menuBuilder.currentMenuToDelete.hash
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {

              this.$store.commit('auth/REMOVE_APPLICATION_MENU_ITEM', this.$store.state.menuBuilder.currentMenuToDelete.hash)

              document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
                item.classList.remove('router-link-exact-active')
                item.classList.remove('router-link-active')
              })

              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação Realizada!',
                text: 'Menu excluído com sucesso!',
                iconPack: 'feather',
                icon: 'icon-success-circle',
                color: 'success'
              })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao excluir o menu',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada',
            text: 'Ocorreu um erro ao excluir o menu',
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })
    },
    prepareAddMenu () {
      this.menuForm.buttonLabel = 'Adicionar Menu'
      this.menuForm.clearLabel = 'Limpar'
      this.menuForm.action = 1
    },
    prepareEditMenu (menuData) {
      this.menuForm.buttonLabel = 'Atualizar Menu'
      this.menuForm.clearLabel = 'Cancelar Edição'
      this.menuForm.action = 2
      this.menuData.type = {}
      this.menuData.addTo = {}
      this.menuData.icon = {}
      this.menuData.module = {}
      this.typeDisabled = true


      const menuElement = document.querySelector(`[data-hash="${menuData.hash}"]`)

      if (menuElement.classList.contains('vs-sidebar--item')) {
        this.menuData.name = menuElement.querySelector('a > span.truncate').textContent
      } else if (menuElement.classList.contains('vs-sidebar-group')) {
        this.menuData.name = menuElement.querySelector('div.group-header > span.flex > span.truncate').textContent
      } else if (menuElement.classList.contains('navigation-header')) {
        this.menuData.name = menuElement.querySelector('span').textContent
      }

      // this.menuData.name = menuData.name
    },
    getAnchorsAndAllGroups () {
      const menuItems = document.querySelector('.vs-sidebar--items > div > section > div')

      const anchorsAndAllGroups = []

      anchorsAndAllGroups.push({
        type: 'title',
        name: 'Âncoras disponíveis:'
      })

      menuItems.querySelectorAll('span').forEach((menuItem) => {

        if (menuItem.tagName.toLowerCase() === 'span' && menuItem.classList.contains('navigation-header')) {
          // Anchor

          anchorsAndAllGroups.push({
            type: 'anchor',
            name: menuItem.textContent.trim(),
            hash: menuItem.getAttribute('data-hash')
          })

        }
      })

      anchorsAndAllGroups.push({
        type: 'title',
        name: 'Grupos disponíveis:'
      })

      menuItems.children.forEach((menuItem) => {

        if (menuItem.classList.contains('vs-sidebar-group')) {
          // Group

          anchorsAndAllGroups.push({
            type: 'group',
            name: menuItem.querySelector('div > span.flex > span.truncate').textContent.trim(),
            hash: menuItem.getAttribute('data-hash')
          })

          menuItem.querySelector('ul > div').children.forEach((groupItem) => {
            if (groupItem.querySelector('div').classList.contains('vs-sidebar-group')) {
              anchorsAndAllGroups.push({
                type: 'group',
                name: groupItem.querySelector('div > span.flex > span.truncate').textContent.trim(),
                hash: groupItem.querySelector('div').getAttribute('data-hash')
              })
            }
          })
        }
      })

      return anchorsAndAllGroups
    },
    getAnchorsAndAllGroupsLevelOne () {
      const menuItems = document.querySelector('.vs-sidebar--items > div > section > div')

      const anchorsAndAllGroups = []

      anchorsAndAllGroups.push({
        type: 'title',
        name: 'Âncora'
      })

      menuItems.querySelectorAll('span').forEach((menuItem) => {

        if (menuItem.tagName.toLowerCase() === 'span' && menuItem.classList.contains('navigation-header')) {
          // Anchor

          anchorsAndAllGroups.push({
            type: 'anchor',
            name: menuItem.textContent.trim(),
            hash: menuItem.getAttribute('data-hash')
          })

        }
      })

      anchorsAndAllGroups.push({
        type: 'title',
        name: 'Grupo'
      })

      menuItems.children.forEach((menuItem) => {

        if (menuItem.classList.contains('vs-sidebar-group')) {
          // Group

          anchorsAndAllGroups.push({
            type: 'group',
            name: menuItem.querySelector('div > span.flex > span.truncate').textContent.trim(),
            hash: menuItem.getAttribute('data-hash')
          })

        }
      })

      return anchorsAndAllGroups
    },
    validateForm () {

      if (this.menuData.addTo.type === 'title') {
        this.$vs.notify({
          title: 'Atenção!',
          text: 'Selecione uma opção válida no campo Inserir Em',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.menuData.name) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo "Nome" não pode ser vazio',
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.menuData.type && Object.keys(this.menuData.type).length === 0 && this.menuData.type.constructor === Object) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo "Tipo" não pode ser vazio',
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (JSON.stringify(this.directTo) !== '{}' && this.directTo.value === 'module' && this.menuData.type.value === 3 && Object.keys(this.menuData.module).length === 0 && this.menuData.module.constructor === Object) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo "Corresponde ao Módulo" não pode ser vazio',
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (JSON.stringify(this.directTo) !== '{}' && this.directTo.value === 'module' && this.menuData.type.value === 3 && this.menuData.module && Object.keys(this.menuData.moduleAction).length === 0 && this.menuData.moduleAction.constructor === Object && this.menuData.module.type_id !== 2) {

        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo "Adicionar à função do módulo" não pode ser vazio',
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.menuData.type.value === 3 && !this.menuData.moduleRecord && (this.menuData.moduleAction.value === 'view' || this.menuData.moduleAction.value === 'edit')) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo "Registro do Módulo" não pode ser vazio',
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (true === false) {
        if (this.menuData.icon && Object.keys(this.menuData.icon).length === 0 && this.menuData.icon.constructor === Object) {
          this.$vs.notify({
            title: 'Atenção',
            text: 'O campo "Ícone" não pode ser vazio',
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'warning'
          })

          return false
        }

        if (this.menuData.module && Object.keys(this.menuData.module).length === 0 && this.menuData.module.constructor === Object) {
          this.$vs.notify({
            title: 'Atenção',
            text: 'O campo "Correspondente ao Módulo" não pode ser vazio',
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'warning'
          })

          return false
        }

        if (this.menuData.addTo && Object.keys(this.menuData.addTo).length === 0 && this.menuData.addTo.constructor === Object) {
          this.$vs.notify({
            title: 'Atenção',
            text: 'O campo "Inserir Em" não pode ser vazio',
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'warning'
          })

          return false
        }
      }

      return true
    },
    stopPropagationClick (e) {
      e.stopPropagation()
    },
    initView () {
      // this.$vs.loading({type: 'default'})
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    editButtonClick () {
      // this.$store.commit('menuBuilder/setCurrentMenuToEdit', {
      //   hash: hash
      // })
    },
    clearForm () {
      this.menuData.name = ''
      this.menuData.icon = {}
      this.menuData.module = {}
      this.menuData.type = {}
      this.menuData.addTo = {}
      this.menuData.moduleAction = {}
      this.menuData.moduleRecord = ''
      this.menuData.externalLink = ''
      this.typeDisabled = false
    },
    async saveChanges () {

      if (this.menuForm.action === 1) {
        if (!this.validateForm()) return

        // this.$vs.loading({type: 'default'})

        const menuName = this.menuData.name

        const moduleHash = this.menuData.module.hash

        const menu = document.querySelector('.vs-sidebar--items > div > section > div')

        let moduleUrl = ''

        let moduleList = null

        if (this.menuData.moduleList.hasOwnProperty('hash')) {
          moduleList = this.menuData.moduleList.hash
        }

        if(JSON.stringify(this.menuData.module) !== '{}') {
          if ( this.menuData.module.type_id === 3) {
          moduleUrl = `/modules/${  moduleHash}`
        } else {
          moduleUrl = `/modules/view/${  moduleHash}`
        }
        }

        if (this.menuData.type.value === 1) {

          await performFetch(this.$store.state.auth.api_url, {
            command: 'add_application_mainmenu_item',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              menu_item: {
                role_hash: this.menuData.role.hash,
                parent_hash: this.menuData.addTo.hash,
                icon_hash: this.menuData.icon.hash,
                title: menuName,
                badge: null,
                module_hash: moduleHash,
                external_link: null,
                module_action: this.menuData.moduleAction.value,
                module_record: this.menuData.moduleRecord,
                type_id: this.menuData.type.value
              }
            }
          })
            .then(async (response) => {
              if (response.status === 200) {

                response.json().then(responseData => {
                  const newItemHash = responseData.payload.hash

                  this.$store.commit('auth/ADD_APPLICATION_MENU_ANCHOR', {
                    hash: newItemHash,
                    header: menuName,
                    icon: this.menuData.icon.value,
                    items: []
                  })

                  document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
                    item.classList.remove('router-link-exact-active')
                    item.classList.remove('router-link-active')
                  })

                  this.clearForm()

                  this.$vs.loading.close()

                  this.$vs.notify({
                    title: 'Operação Realizada!',
                    text: 'Menu adicionado com sucesso!',
                    iconPack: 'feather',
                    icon: 'icon-success-circle',
                    color: 'success'
                  })

                  this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)
                })
              } else if (response.status == 401) {
                setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                this.$store.dispatch('auth/signOut')
                console.log(401)
              } else {
                console.log(500)
              }
            })
            .catch((e) => {

              console.log(e)
            })
        } else if (this.menuData.type.value === 2) {

          if (this.menuData.addTo.type === 'group') {

            await performFetch(this.$store.state.auth.api_url, {
              command: 'add_application_mainmenu_item',
              parameters: {
                application_token: this.$store.state.auth.app_token,
                session_token: this.$store.state.auth.token,
                menu_item: {
                  role_hash: this.menuData.role.hash,
                  parent_hash: this.menuData.addTo.hash,
                  icon_hash: this.menuData.icon.hash,
                  title: menuName,
                  badge: null,
                  module_hash: null,
                  external_link: null,
                  type_id: this.menuData.type.value
                }
              }
            })
              .then(async (response) => {
                if (response.status === 200) {

                  response.json().then(responseData => {
                    const newItemHash = responseData.payload.hash

                    this.$store.commit('auth/ADD_APPLICATION_MENU_GROUP', {
                      parentHash: this.menuData.addTo.hash,
                      hash: newItemHash,
                      name: menuName,
                      url: '/modules'
                    })

                    if (this.menuData.type.value === 2) {
                      setTimeout(() => {
                        document.querySelector(`[data-hash="${newItemHash}"] > ul > div`).innerHTML = '<li></li><li></li><li></li>'
                      }, 300)
                    }

                    document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
                      item.classList.remove('router-link-exact-active')
                      item.classList.remove('router-link-active')
                    })

                    this.clearForm()

                    this.$vs.loading.close()

                    this.$vs.notify({
                      title: 'Operação Realizada!',
                      text: 'Menu adicionado com sucesso!',
                      iconPack: 'feather',
                      icon: 'icon-success-circle',
                      color: 'success'
                    })

                    this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)
                  })
                } else if (response.status == 401) {
                  setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                  this.$store.dispatch('auth/signOut')
                } else {
                  console.log(500)
                }
              })
              .catch((e) => {

                console.log(e)
              })

          } else if (this.menuData.addTo.type === 'anchor') {

            await performFetch(this.$store.state.auth.api_url, {
              command: 'add_application_mainmenu_item',
              parameters: {
                application_token: this.$store.state.auth.app_token,
                session_token: this.$store.state.auth.token,
                menu_item: {
                  role_hash: this.menuData.role.hash,
                  parent_hash: this.menuData.addTo.hash,
                  icon_hash: this.menuData.icon.hash,
                  title: menuName,
                  badge: null,
                  module_hash: null,
                  external_link: null,
                  type_id: this.menuData.type.value
                }
              }
            })
              .then(async (response) => {
                if (response.status === 200) {

                  response.json().then(responseData => {
                    const newItemHash = responseData.payload.hash

                    this.$store.commit('auth/ADD_APPLICATION_MENU_GROUP', {
                      parentHash: this.menuData.addTo.hash,
                      hash: newItemHash,
                      name: menuName,
                      url: '/modules',
                      icon: this.menuData.icon.value
                    })

                    document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
                      item.classList.remove('router-link-exact-active')
                      item.classList.remove('router-link-active')
                    })

                    this.clearForm()

                    this.$vs.loading.close()

                    this.$vs.notify({
                      title: 'Operação Realizada!',
                      text: 'Menu adicionado com sucesso!',
                      iconPack: 'feather',
                      icon: 'icon-success-circle',
                      color: 'success'
                    })

                    this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)
                  })
                } else if (response.status == 401) {
                  setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                  this.$store.dispatch('auth/signOut')
                  console.log(401)
                } else {
                  console.log(500)
                }
              })
              .catch((e) => {

                console.log(e)
              })
          }

        } else if (this.menuData.type.value === 3) {

          let moduleRecord = this.menuData.moduleRecord

          if (this.menuData.module.type_id === 2) {
            moduleRecord = this.menuData.module.hash
          }

          await performFetch(this.$store.state.auth.api_url, {
            command: 'add_application_mainmenu_item',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              menu_item: {
                role_hash: this.menuData.role.hash,
                parent_hash: this.menuData.addTo.hash,
                icon_hash: this.menuData.icon.hash,
                title: menuName,
                badge: null,
                module_hash: moduleHash,
                external_link: null,
                module_action: this.menuData.moduleAction.value,
                module_record: moduleRecord,
                module_list: moduleList,
                direct_to: JSON.stringify(this.directTo) !== '{}' ? this.directTo.value : null,
                dashboard_hash: this.menuData.dashboard.hasOwnProperty('hash') ? this.menuData.dashboard.hash : null,
                type_id: this.menuData.type.value
              }
            }
          })
            .then(async (response) => {
              if (response.status === 200) {

                response.json().then(responseData => {
                  const newItemHash = responseData.payload.hash
                  const newItemUrl = responseData.payload.route

                  const newMenuObject = {
                    hash: newItemHash,
                    parentHash: this.menuData.addTo.hash,
                    name: menuName,
                    url: newItemUrl,
                    icon: this.menuData.icon.value
                  }

                  this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', newMenuObject)

                  setTimeout(() => {
                    document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
                      item.classList.remove('router-link-exact-active')
                      item.classList.remove('router-link-active')
                    })
                  })

                  this.clearForm()

                  this.$vs.loading.close()

                  this.$vs.notify({
                    title: 'Operação Realizada!',
                    text: 'Menu adicionado com sucesso!',
                    iconPack: 'feather',
                    icon: 'icon-success-circle',
                    color: 'success'
                  })

                  this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)
                })
              } else if (response.status == 401) {
                setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                this.$store.dispatch('auth/signOut')
                console.log(401)
              } else {
                console.log(500)
              }
            })
            .catch((e) => {

              console.log(e)
            })
        } else if (this.menuData.type.value === 4 || this.menuData.type.value === 5) {

          await performFetch(this.$store.state.auth.api_url, {
            command: 'add_application_mainmenu_item',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              menu_item: {
                role_hash: this.menuData.role.hash,
                parent_hash: this.menuData.addTo.hash,
                icon_hash: this.menuData.icon.hash,
                title: menuName,
                badge: null,
                module_hash: null,
                external_link: this.menuData.externalLink,
                module_action: null,
                module_record: null,
                type_id: this.menuData.type.value

              }
            }
          })
            .then(async (response) => {
              if (response.status === 200) {

                response.json().then(responseData => {
                  const newItemHash = responseData.payload.hash
                  const newItemUrl = responseData.payload.route

                  const newMenuObject = {
                    hash: newItemHash,
                    parentHash: this.menuData.addTo.hash,
                    name: menuName,
                    url: newItemUrl,
                    icon: this.menuData.icon.value
                  }

                  this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', newMenuObject)

                  setTimeout(() => {
                    document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
                      item.classList.remove('router-link-exact-active')
                      item.classList.remove('router-link-active')
                    })
                  })

                  this.clearForm()

                  this.$vs.loading.close()

                  this.$vs.notify({
                    title: 'Operação Realizada!',
                    text: 'Menu adicionado com sucesso!',
                    iconPack: 'feather',
                    icon: 'icon-success-circle',
                    color: 'success'
                  })

                  this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)
                })
              } else if (response.status == 401) {
                setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                this.$store.dispatch('auth/signOut')
                console.log(401)
              } else {
                console.log(500)
              }
            })
            .catch((e) => {

              console.log(e)
            })
        }

        this.$vs.loading.close()
      } else {

        const menuHash = this.$store.state.menuBuilder.currentMenuToEdit.hash

        this.$store.commit('auth/SET_MENU_NAME', {hash: menuHash, name: this.menuData.name})

        this.menuForm.buttonLabel = 'Adicionar Menu'
        this.menuForm.action = 1
        this.typeDisabled = false
        this.menuData.name = ''
      }
    }
  }
}
</script>
<style scoped>
.vs-con-tbody {
  border: none !important;
}

.icon-select .vs__dropdown-menu {

  height: 80px !important;
  z-index: 200001!important;
}

.module-select .vs__dropdown-menu {

  height: 80px !important;
}

.addto-select .vs__dropdown-menu {

  height: 80px !important;
}
</style>
